(function(){
'use strict';

function reverse() {
  return function (items) {
    return items.slice().reverse();
  };
}

angular.module('classy').filter('reverse', reverse);
})();